import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  GetActualExpenseTransferSignatoriesArgs,
  OrganizationSignatoriesResponse,
  TransferActForm,
} from './types';

const transformAppendix2ExportKeyResponse = (response: any, meta: any) => {
  const requestBody = meta?.body;

  const id = typeof response === 'string' ? response : response?.id;

  return {
    link: `${Config.VITE_ANALYTICS_API_URL}/reports/actual-expense-transfer-act/export/${id}`,
    requestBody,
  };
};

export const actualExpenseTransferApi = createApi({
  reducerPath: 'actualExpenseTransferApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_ANALYTICS_API_URL}/reports/actual-expense-transfer-act`,
  }),
  endpoints: builder => ({
    getActualExpenseTransfer: builder.mutation<
      { link: string },
      TransferActForm
    >({
      query: body => ({
        url: `/export-key`,
        method: 'POST',
        data: body,
        meta: { body },
      }),
      transformResponse: transformAppendix2ExportKeyResponse,
    }),
    getActualExpenseTransferSignatories: builder.query<
      OrganizationSignatoriesResponse,
      GetActualExpenseTransferSignatoriesArgs
    >({
      query: params => ({
        url: `/signatories`,
        params,
      }),
    }),
  }),
});

export const {
  useGetActualExpenseTransferMutation,
  useGetActualExpenseTransferSignatoriesQuery,
  useLazyGetActualExpenseTransferSignatoriesQuery,
} = actualExpenseTransferApi;
